<template>
  <div class="ai-consulting-page">
    <!-- 面包屑导航 -->
    <nav class="breadcrumb-nav">
      <router-link to="/">首页</router-link>
      <span class="separator">/</span>
      <router-link to="/consulting">咨询</router-link>
      <span class="separator">/</span>
      <span class="current">AI及大模型咨询</span>
    </nav>

    <!-- 1️⃣ Banner区 -->
    <section id="banner" class="section">
      <div class="banner">
        <div class="grid-2">
          <div>
            <h1>AI及大模型咨询</h1>
            <div class="banner-sub">技术底座赋能者。以AI代理和数据集成能力为核心，帮助企业无需重构基础设施即可部署AI，数据资产转化为商业洞察，构建AI驱动的业务平台，内部验证后外化。</div>
            <div class="banner-tags">
              <h2 class="banner-tag">AI 人工智能  智能体</h2>  
              <h2 class="banner-tag">AI咨询 规划</h2>
              <h2 class="banner-tag">AI场景</h2>
              <h2 class="banner-tag">AI智能体应用</h2>

              <h2 class="banner-tag">AI战略规划</h2>
              <h2 class="banner-tag">大模型场景落地</h2>

            </div>
            <div class="banner-buttons">
              <a href="#" class="btn-primary" @click.prevent="showModal = true">预约专家咨询</a>
              <a href="#" class="btn-outline-light" @click.prevent="downloadWhitepaper">下载AI白皮书</a>
            </div>
          </div>
          <div class="banner-visual">
            <div class="network-grid">
              <i class="fas fa-brain"></i>
              <i class="fas fa-circle-nodes"></i>
              <i class="fas fa-microchip"></i>
            </div>
          </div>
        </div>
      </div>
    </section>

        <!-- 固定导航 -->
    <section class="nav-fixed">
      <div class="nav-container">
        <div class="nav-menu-inner">
          <a href="#banner" class="nav-item-inner" :class="{ active: currentSection === 'banner' }" @click.prevent="scrollTo('banner')">首页</a>
          <a href="#services" class="nav-item-inner" :class="{ active: currentSection === 'services' }" @click.prevent="scrollTo('services')">服务内容</a>
          <a href="#features" class="nav-item-inner" :class="{ active: currentSection === 'features' }" @click.prevent="scrollTo('features')">服务特点</a>
          <a href="#methodology" class="nav-item-inner" :class="{ active: currentSection === 'methodology' }" @click.prevent="scrollTo('methodology')">方法论</a>
          <a href="#clients" class="nav-item-inner" :class="{ active: currentSection === 'clients' }" @click.prevent="scrollTo('clients')">成功客户</a>
          <a href="#articles" class="nav-item-inner" :class="{ active: currentSection === 'articles' }" @click.prevent="scrollTo('articles')">专题文章</a>
          <a href="#contact" class="nav-item-inner" :class="{ active: currentSection === 'contact' }" @click.prevent="scrollTo('contact')">预约咨询</a>
        </div>
      </div>
    </section>

    <!-- 2️⃣ 咨询服务内容（六卡片） -->
    <section id="services" class="section">
      <div class="container">
        <h2>AI及大模型咨询服务内容</h2>
        <div class="grid-3">
          <div class="service-card" :class="{ active: activeCards.includes(0) }" @click="toggleCard(0)">
            <div class="card-icon"><i class="fas fa-chess-queen"></i></div>
            <h3>AI战略与顶层设计</h3>
            <p>制定企业级AI愿景、战略路径与治理框架、AI实施路径及落地路线</p>
            <div class="service-detail">
              <strong>交付物：</strong>AI战略规划、实施路线图、投资回报模型
            </div>
          </div>
          <div class="service-card" :class="{ active: activeCards.includes(1) }" @click="toggleCard(1)">
            <div class="card-icon"><i class="fas fa-cloud"></i></div>
            <h3>企业大模型规划与部署</h3>
            <p>大模型选型、私有化部署、微调与提示工程、模型优化与监控、大模型技能培训</p>
            <div class="service-detail">
              <strong>交付物：</strong>模型选型报告、部署架构、微调数据集
            </div>
          </div>
          <div class="service-card" :class="{ active: activeCards.includes(2) }" @click="toggleCard(2)">
            <div class="card-icon"><i class="fas fa-industry"></i></div>
            <h3>行业AI场景落地</h3>
            <p>聚焦能源、金融、制造高价值场景，聚焦财务、审计、风控合规、供应链、人资AI应用</p>
            <div class="service-detail">
              <strong>交付物：</strong>场景试点方案、ROI分析、规模化路径
            </div>
          </div>
          <div class="service-card" :class="{ active: activeCards.includes(3) }" @click="toggleCard(3)">
            <div class="card-icon"><i class="fas fa-shield"></i></div>
            <h3>数据与模型治理</h3>
            <p>AI数据基础治理、模型生命周期管理、模型优化与监控</p>
            <div class="service-detail">
              <strong>交付物：</strong>数据治理框架、模型监控体系
            </div>
          </div>
          <div class="service-card" :class="{ active: activeCards.includes(4) }" @click="toggleCard(4)">
            <div class="card-icon"><i class="fas fa-balance-scale"></i></div>
            <h3>AI风险与合规管理</h3>
            <p>算法合规、伦理审查、隐私保护、模型风险评估、AI内容审计治理</p>
            <div class="service-detail">
              <strong>交付物：</strong>合规检查清单、风险评估报告
            </div>
          </div>
          <div class="service-card" :class="{ active: activeCards.includes(5) }" @click="toggleCard(5)">
            <div class="card-icon"><i class="fas fa-users"></i></div>
            <h3>AI组织与能力建设</h3>
            <p>AI人才梯队、组织架构、培训体系、AI人才评价</p>
            <div class="service-detail">
              <strong>交付物：</strong>组织设计、培训课程、能力评估
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 3️⃣ 服务特点（四卡片） -->
    <section id="features" class="section">
      <div class="container">
        <h2>AI咨询服务特点</h2>
        <div class="grid-4">
          <div class="service-card">
            <div class="card-icon"><i class="fas fa-bullseye"></i></div>
            <h3>场景驱动</h3>
            <p>从业务价值出发，选择高回报AI场景快速落地。</p>
          </div>
          <div class="service-card">
            <div class="card-icon"><i class="fas fa-database"></i></div>
            <h3>数据+AI一体化</h3>
            <p>数据治理与AI建设同步，确保AI应用质量。</p>
          </div>
          <div class="service-card">
            <div class="card-icon"><i class="fas fa-lock"></i></div>
            <h3>私有化与安全可控</h3>
            <p>支持私有化部署，保障企业数据安全。</p>
          </div>
          <div class="service-card">
            <div class="card-icon"><i class="fas fa-rotate"></i></div>
            <h3>可持续迭代优化</h3>
            <p>建立持续学习与模型迭代机制、优化策略与反馈闭环。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 4️⃣ 咨询方法论（五阶段时间轴） -->
    <section id="methodology" class="section">
      <div class="container">
        <h2>AI咨询五阶段方法论</h2>
        <div class="timeline-horizontal">
          <div class="timeline-step" @click="activeStep = 1">
            <div class="timeline-marker">1</div>
            <div class="timeline-title">AI成熟度评估</div>
          </div>
          <div class="timeline-step" @click="activeStep = 2">
            <div class="timeline-marker">2</div>
            <div class="timeline-title">战略与蓝图设计</div>
          </div>
          <div class="timeline-step" @click="activeStep = 3">
            <div class="timeline-marker">3</div>
            <div class="timeline-title">数据与架构规划</div>
          </div>
          <div class="timeline-step" @click="activeStep = 4">
            <div class="timeline-marker">4</div>
            <div class="timeline-title">场景试点落地</div>
          </div>
          <div class="timeline-step" @click="activeStep = 5">
            <div class="timeline-marker">5</div>
            <div class="timeline-title">治理与持续优化</div>
          </div>
        </div>
        <div class="step-detail" :class="{ active: activeStep === 1 }">
          <h3>AI成熟度评估</h3>
          <p>数据能力评估 · 技术设施评估 · 组织准备度评估</p>
          <div class="step-output">输出：AI成熟度报告、差距分析</div>
        </div>
        <div class="step-detail" :class="{ active: activeStep === 2 }">
          <h3>战略与蓝图设计</h3>
          <p>AI愿景 · 战略路径 · 投资优先级</p>
          <div class="step-output">输出：AI战略规划、三年路线图</div>
        </div>
        <div class="step-detail" :class="{ active: activeStep === 3 }">
          <h3>数据与架构规划</h3>
          <p>数据平台设计 · AI架构选型 · 技术标准</p>
          <div class="step-output">输出：技术蓝图、数据治理方案</div>
        </div>
        <div class="step-detail" :class="{ active: activeStep === 4 }">
          <h3>场景试点落地</h3>
          <p>高价值场景识别 · 敏捷试点 · 效果评估</p>
          <div class="step-output">输出：试点成果报告、规模化建议</div>
        </div>
        <div class="step-detail" :class="{ active: activeStep === 5 }">
          <h3>治理与持续优化</h3>
          <p>模型监控 · 合规审计 · 迭代机制</p>
          <div class="step-output">输出：治理框架、持续运营体系</div>
        </div>
        <!-- 
        <div style="text-align: center;">
          <button class="download-pdf" @click="downloadPdf"><i class="fas fa-download"></i> 下载方法论PDF</button>
        </div>
         -->
      </div>
    </section>

    <!-- 5️⃣ 成功客户模块 -->
    <section id="clients" class="section">
      <div class="container">
        <h2>成功客户</h2>
        <div class="industry-filter">
          <span class="filter-btn" :class="{ active: activeFilter === 'all' }" @click="activeFilter = 'all'">全部</span>
          <span class="filter-btn" :class="{ active: activeFilter === 'energy' }" @click="activeFilter = 'energy'">能源电力</span>
          <span class="filter-btn" :class="{ active: activeFilter === 'finance' }" @click="activeFilter = 'finance'">金融保险</span>
          <span class="filter-btn" :class="{ active: activeFilter === 'manufacturing' }" @click="activeFilter = 'manufacturing'">制造业</span>
          <span class="filter-btn" :class="{ active: activeFilter === 'government' }" @click="activeFilter = 'government'">政府单位</span>
        </div>
        <div class="logo-wall">
          <div v-for="client in filteredClients" :key="client.name" class="logo-item">
            {{ client.name }}
            <div class="logo-tooltip">{{ client.desc }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 6️⃣ AI专题文章模块 -->
    <section id="articles" class="section">
      <div class="container">
        <h2>AI专题文章</h2>
        <div class="grid-3">
          <div class="article-card">
            <div class="article-meta">
              <span>2025-04-15</span>
              <span class="article-tag">私有化大模型</span>
            </div>
            <h3>企业私有化大模型实践</h3>
            <p style="color: #5f6a7d;">从选型到部署，如何构建安全可控的企业级大模型。</p>
            <span class="read-link">阅读专题 →</span>
          </div>
          <div class="article-card">
            <div class="article-meta">
              <span>2025-03-28</span>
              <span class="article-tag">审计风控</span>
            </div>
            <h3>大模型在审计与风控中的应用</h3>
            <p style="color: #5f6a7d;">智能审计、风险预警、合规检查的AI实践。</p>
            <span class="read-link">阅读专题 →</span>
          </div>
          <div class="article-card">
            <div class="article-meta">
              <span>2025-02-20</span>
              <span class="article-tag">AI治理</span>
            </div>
            <h3>AI治理框架设计</h3>
            <p style="color: #5f6a7d;">从原则到可执行的AI治理体系。</p>
            <span class="read-link">阅读专题 →</span>
          </div>
          <div class="article-card">
            <div class="article-meta">
              <span>2025-01-12</span>
              <span class="article-tag">AIGC</span>
            </div>
            <h3>企业AIGC落地路径</h3>
            <p style="color: #5f6a7d;">内容生成、知识库、办公助手等场景。</p>
            <span class="read-link">阅读专题 →</span>
          </div>
          <div class="article-card">
            <div class="article-meta">
              <span>2024-12-05</span>
              <span class="article-tag">合规</span>
            </div>
            <h3>AI合规与风险管理</h3>
            <p style="color: #5f6a7d;">算法备案、数据安全、伦理审查。</p>
            <span class="read-link">阅读专题 →</span>
          </div>
          <div class="article-card">
            <div class="article-meta">
              <span>2024-11-18</span>
              <span class="article-tag">AI战略</span>
            </div>
            <h3>央国企AI战略规划指南</h3>
            <p style="color: #5f6a7d;">从顶层设计到落地执行的完整框架。</p>
            <span class="read-link">阅读专题 →</span>
          </div>
        </div>
        <div class="load-more">
          <button class="btn-load-more" @click="loadMore">加载更多</button>
        </div>
      </div>
    </section>


    <!-- 7️⃣ 底部转化模块 -->
    <section id="contact" class="section cta-section">
      <h2>预约咨询</h2>
      <div class="cta-inner">
        <h3 class="cta-heading">构建企业级 AI 战略与大模型落地应用体系</h3>
        <p class="cta-sub">当前已服务 100+ 央企国企，覆盖能源、电力、制造、金融等重点行业</p>
        <div class="cta-actions">
          <button class="cta-btn cta-btn--primary" @click="showModal = true">
            <i class="fas fa-calendar-check"></i>
            预约咨询
          </button>
          <button class="cta-btn cta-btn--outline" @click="showQrCode">
            <i class="fab fa-weixin"></i>
            扫码添加顾问
          </button>
        </div>
        <div class="cta-contact-row">
          <span><i class="fas fa-phone-alt"></i> 185-1017-6330</span>
          <span class="divider">|</span>
          <span><i class="fas fa-envelope"></i> pmo@gushandata.cn</span>
          <span class="divider">|</span>
          <span><i class="fas fa-clock"></i> 1小时内响应 · 严格保密</span>
        </div>
      </div>
    </section>

    <!-- 预约咨询弹窗 -->
    <transition name="modal-fade">
    <div class="modal-overlay" v-if="showModal" @click.self="showModal = false">
      <div class="modal-container appointment-modal">
        <div class="modal-header">
          <div class="modal-header-icon"><i class="fas fa-calendar-check"></i></div>
          <div>
            <h3 class="modal-title">预约专家一对一咨询</h3>
            <p class="modal-subtitle">我们将在 1 小时内安排资深顾问与您联系</p>
          </div>
          <button class="modal-close-btn" @click="showModal = false"><i class="fas fa-times"></i></button>
        </div>
        <form class="appt-form" @submit.prevent="submitForm">
          <div class="form-row">
            <div class="form-group">
              <label>姓名 <span class="required">*</span></label>
              <input type="text" placeholder="请输入您的姓名" required />
            </div>
            <div class="form-group">
              <label>联系电话 <span class="required">*</span></label>
              <input type="tel" placeholder="便于顾问联系您" required />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>公司名称</label>
              <input type="text" placeholder="您所在的公司" />
            </div>
            <div class="form-group">
              <label>职位</label>
              <input type="text" placeholder="您的职位/部门" />
            </div>
          </div>
          <div class="form-group">
            <label>咨询方向</label>
            <select>
              <option value="">-- 请选择咨询方向 --</option>
              <option>AI 战略规划 / 顶层设计</option>
              <option>大模型选型与落地</option>
              <option>AI 沿业务场景落地</option>
              <option>AI 治理与安全合规</option>
              <option>智能体平台建设</option>
              <option>其他（请备注）</option>
            </select>
          </div>
          <div class="form-group">
            <label>补充说明</label>
            <textarea rows="2" placeholder="简述您的业务场景或待解决的问题（可选）"></textarea>
          </div>
          <button type="submit" class="form-submit-btn">
            <i class="fas fa-paper-plane"></i> 提交预约
          </button>
          <p class="form-privacy"><i class="fas fa-lock"></i> 您的信息将严格保密，仅用于本次咨询联系</p>
        </form>
      </div>
    </div>
    </transition>

    <!-- 扫码添加顾问弹窗 -->
    <transition name="modal-fade">
    <div class="modal-overlay" v-if="showQrModal" @click.self="showQrModal = false">
      <div class="modal-container qr-modal">
        <div class="modal-header">
          <div class="modal-header-icon qr-header-icon"><i class="fab fa-weixin"></i></div>
          <div>
            <h3 class="modal-title">扫码添加顾问</h3>
            <p class="modal-subtitle">加微信，获取一对一专属服务</p>
          </div>
          <button class="modal-close-btn" @click="showQrModal = false"><i class="fas fa-times"></i></button>
        </div>
        <div class="qr-grid">
          <div class="qr-card" v-for="(img, idx) in qrImages" :key="idx">
            <div class="qr-img-wrap">
              <img v-if="img" :src="img" :alt="'顾问二维码 ' + (idx+1)" class="qr-img" />
              <div v-else class="qr-placeholder"><i class="fab fa-weixin"></i><span>二维码占位</span></div>
            </div>
            <div class="qr-card-label">扫码添加「AI 咨询」专属顾问</div>
            <div class="qr-scan-hint"><i class="fas fa-qrcode"></i> 扫一扫即可添加</div>
          </div>
        </div>
        <p class="qr-footer-tip">或致电 <strong>185-1017-6330</strong> 直接预约顶层顾问服务</p>
      </div>
    </div>
    </transition>

  </div>
</template>

<script>
export default {
  name: 'ConsultDetailAiConsulting',
  data() {
    return {
      currentSection: 'banner',
      activeStep: 1,
      activeFilter: 'all',
      showModal: false,
      showQrModal: false,
      qrImages: [require('@/assets/img/qr_gu.jpg'), require('@/assets/img/qr_sang.jpg')],
      activeCards: [],
      clients: [
        { name: '国家能源集团', industry: 'energy', desc: 'AI设备预测性维护' },
        { name: '中国建设银行', industry: 'finance', desc: '大模型智能客服' },
        { name: '中国中车', industry: 'manufacturing', desc: '工业视觉质检' },
        { name: '南方电网', industry: 'energy', desc: '负荷预测大模型' },
        { name: '国家政务服务平台', industry: 'government', desc: 'AI政务问答' },
        { name: '中国人寿', industry: 'finance', desc: '智能核保与风控' }
      ]
    }
  },
  computed: {
    filteredClients() {
      if (this.activeFilter === 'all') return this.clients
      return this.clients.filter(c => c.industry === this.activeFilter)
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    scrollTo(id) {
      const el = document.getElementById(id)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    },
    handleScroll() {
      const sections = this.$el.querySelectorAll('.section')
      const scrollPos = window.pageYOffset + 100
      sections.forEach(section => {
        const top = section.offsetTop - 70
        const bottom = top + section.offsetHeight
        if (scrollPos >= top && scrollPos < bottom && section.id) {
          this.currentSection = section.id
        }
      })
    },
    toggleCard(index) {
      const idx = this.activeCards.indexOf(index)
      if (idx > -1) {
        this.activeCards.splice(idx, 1)
      } else {
        this.activeCards.push(index)
      }
    },
    downloadPdf() {
      console.log('PDF下载点击埋点')
      alert('PDF下载功能已触发，可在此处集成真实下载逻辑。')
    },
    downloadWhitepaper() {
      alert('AI白皮书下载已触发')
    },
    loadMore() {
      this.$router.push('/consulting/ai-consulting/articles')
    },
    submitForm() {
      alert('表单已提交')
      this.showModal = false
    },
    showQrCode() {
      this.showQrModal = true
    }
  }
}
</script>

<style scoped>
/* 面包屑 */
.breadcrumb-nav {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px 24px;
  font-size: 14px;
  color: #5f6a7d;
}
.breadcrumb-nav a {
  color: #1F3F8F;
  text-decoration: none;
}
.breadcrumb-nav a:hover {
  text-decoration: underline;
}
.breadcrumb-nav .separator {
  margin: 0 8px;
  color: #ccc;
}
.breadcrumb-nav .current {
  color: #2B2F3A;
}

.ai-consulting-page {
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  background-color: #ffffff;
  color: #2B2F3A;
  line-height: 1.6;
  --primary-blue: #1F3F8F;
  --deep-indigo: #0E1F52;
  --light-porcelain: #EAF0FB;
  --bg-light: #f5f7fa;
  --text-dark: #2B2F3A;
  --card-shadow: 0 12px 28px rgba(0,10,30,0.04), 0 4px 16px rgba(31,63,143,0.08);
  --border-light: #e9edf4;
  --nav-height: 60px;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}

/* 固定导航 */
.nav-fixed {
  position: sticky;
  top: 60px;
  left: 0;
  width: 100%;
  background-color: white;
  box-shadow: 0 4px 20px rgba(0,0,0,0.02);
  z-index: 999;
  border-bottom: 1px solid rgba(31,63,143,0.1);
  height: var(--nav-height);
  backdrop-filter: blur(8px);
  background: rgba(255,255,255,0.9);
}
.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.nav-menu-inner {
  display: flex;
  gap: 8px;
  background-color: #f5f7fa;
  padding: 4px;
  border-radius: 40px;
}
.nav-item-inner {
  padding: 8px 20px;
  font-size: 15px;
  font-weight: 500;
  color: #2B2F3A;
  border-radius: 32px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  background-color: transparent;
  border: none;
  white-space: nowrap;
}
.nav-item-inner:hover {
  background-color: #EAF0FB;
  color: #1F3F8F;
}
.nav-item-inner.active {
  background-color: #1F3F8F;
  color: white;
  font-weight: 600;
  box-shadow: 0 4px 10px rgba(31,63,143,0.2);
}

/* 通用样式 */
.section {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 16px;
}

@keyframes sectionFadeIn {
  to { opacity: 1; transform: translateY(0); }
}

h1 {
  font-size: 42px;
  font-weight: 700;
  color: white;
  margin-bottom: 24px;
  letter-spacing: -0.02em;
  line-height: 1.2;
}
h2 {
  font-size: 28px;
  font-weight: 700;
  color: var(--deep-indigo);
  margin-bottom: 40px;
  letter-spacing: -0.01em;
  position: relative;
  display: inline-block;
}
h2:after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 60px;
  height: 3px;
  background-color: var(--primary-blue);
  border-radius: 4px;
}
h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
  color: var(--deep-indigo);
}

/* Banner区 */
.banner {
  background: linear-gradient(135deg, #1F3F8F 0%, #0E1F52 100%);
  border-radius: 32px;
  padding: 60px 48px;
  position: relative;
  overflow: hidden;
  margin-top: 20px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.banner::before {
  content: '';
  position: absolute;
  top: -30%;
  right: -10%;
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(234,240,251,0.1) 0%, transparent 70%);
  border-radius: 50%;
  z-index: 0;
}
.banner::after {
  content: '';
  position: absolute;
  bottom: -20%;
  left: -5%;
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(26,115,232,0.15) 0%, transparent 70%);
  border-radius: 50%;
  z-index: 0;
}
.banner .grid-2 {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  align-items: center;
}
.banner-sub {
  font-size: 18px;
  color: rgba(255,255,255,0.9);
  max-width: 550px;
  margin-bottom: 24px;
}
.banner-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 20px 0;
}
.banner-tag {
  background: rgba(255,255,255,0.15);
  color: white;
  padding: 6px 18px;
  border-radius: 40px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid rgba(255,255,255,0.2);
  backdrop-filter: blur(4px);
  transition: all 0.3s;
}
.banner-tag:hover {
  background: rgba(255,255,255,0.25);
  transform: translateY(-2px);
}
.banner-buttons {
  display: flex;
  gap: 16px;
  margin-top: 24px;
}
.btn-primary {
  display: inline-block;
  background: var(--primary-blue);
  color: white;
  border: none;
  padding: 14px 36px;
  border-radius: 60px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
  text-decoration: none;
  font-size: 16px;
}
.btn-primary:hover {
  background: #0e3170;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(31,63,143,0.3);
}

.btn-outline-light {
  background: #EAF0FB;
  color: black;
  border: 1px solid #0e3170;
  padding: 14px 36px;
  border-radius: 60px;
  font-weight: 600;
  transition: 0.3s;
  text-decoration: none;
}
.btn-outline-light:hover {
  background: rgba(255,255,255,0.1);
  border-color: #0e3170;
}


.banner-visual {
  display: flex;
  justify-content: center;
  align-items: center;
}
.network-grid {
  width: 100%;
  max-width: 400px;
  height: 280px;
  background: rgba(255,255,255,0.05);
  border-radius: 24px;
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255,255,255,0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}
.network-grid i {
  font-size: 100px;
  color: rgba(255,255,255,0.2);
  position: absolute;
}
.network-grid .fa-brain {
  font-size: 120px;
  opacity: 0.4;
}
.network-grid .fa-circle-nodes {
  font-size: 140px;
  opacity: 0.2;
}

/* 卡片网格 */
.grid-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}
.grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}
.grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
}
.service-card {
  background: white;
  border-radius: 16px;
  padding: 28px 24px;
  box-shadow: var(--card-shadow);
  transition: all 0.3s ease;
  border: 1px solid rgba(31,63,143,0.05);
  cursor: pointer;
}
.service-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 40px rgba(31,63,143,0.12);
}
.card-icon {
  width: 56px;
  height: 56px;
  background: var(--light-porcelain);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary-blue);
  font-size: 28px;
  margin-bottom: 20px;
}
.feature-tag {
  display: inline-block;
  background: var(--light-porcelain);
  padding: 4px 12px;
  border-radius: 40px;
  font-size: 13px;
  margin-right: 8px;
  margin-top: 12px;
}
.service-detail {
  background: var(--light-porcelain);
  border-radius: 12px;
  padding: 16px;
  margin-top: 16px;
  font-size: 14px;
  display: none;
}
.service-card.active .service-detail {
  display: block;
}

.read-link {
  margin-top: auto;
  padding-top: 16px;
  text-align: right;
  color: #1F3F8F;
  font-size: 14px;
  font-weight: 600;
  transition: color 0.3s;
}



/* 时间轴五阶段 */
.timeline-horizontal {
  display: flex;
  justify-content: space-between;
  margin: 40px 0;
  position: relative;
}
.timeline-step {
  flex: 1;
  text-align: center;
  position: relative;
  cursor: pointer;
}
.timeline-marker {
  width: 40px;
  height: 40px;
  background: var(--primary-blue);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  font-weight: 600;
  transition: all 0.3s;
}
.timeline-step:hover .timeline-marker {
  transform: scale(1.1);
  background: var(--deep-indigo);
}
.timeline-title {
  font-weight: 600;
  margin-bottom: 8px;
}
.step-detail {
  background: var(--light-porcelain);
  border-radius: 16px;
  padding: 24px;
  margin-top: 30px;
  display: none;
}
.step-detail.active {
  display: block;
}
.step-output {
  margin-top: 12px;
  font-size: 14px;
  color: var(--primary-blue);
}
.download-pdf {
  display: inline-block;
  background: var(--primary-blue);
  color: white;
  padding: 12px 28px;
  border-radius: 40px;
  text-decoration: none;
  margin-top: 20px;
  transition: 0.3s;
  border: none;
  cursor: pointer;
}
.download-pdf:hover {
  background: #0e3170;
}

/* Logo墙 + 筛选 */
.industry-filter {
  display: flex;
  gap: 12px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}
.filter-btn {
  padding: 8px 24px;
  border-radius: 40px;
  background: white;
  border: 1px solid var(--border-light);
  cursor: pointer;
  transition: all 0.3s;
}
.filter-btn.active, .filter-btn:hover {
  background: var(--primary-blue);
  color: white;
}
.logo-wall {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: center;
  background: var(--bg-light);
  padding: 40px;
  border-radius: 32px;
}
.logo-item {
  background: white;
  padding: 16px 32px;
  border-radius: 60px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(0,0,0,0.02);
  transition: all 0.3s;
  cursor: pointer;
  border: 1px solid rgba(31,63,143,0.1);
  position: relative;
}
.logo-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(31,63,143,0.15);
}
.logo-tooltip {
  display: none;
  background: var(--deep-indigo);
  color: white;
  padding: 8px 16px;
  border-radius: 40px;
  font-size: 14px;
  margin-top: 8px;
  white-space: nowrap;
  position: absolute;
  bottom: -40px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}
.logo-item:hover .logo-tooltip {
  display: block;
}

/* 文章卡片 */
.article-card {
  background: white;
  border-radius: 16px;
  padding: 28px;
  box-shadow: var(--card-shadow);
  transition: all 0.3s;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.article-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 40px rgba(31,63,143,0.12);
}
.article-meta {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  color: #5f6a7d;
  font-size: 14px;
}
.article-tag {
  background: var(--light-porcelain);
  padding: 4px 12px;
  border-radius: 40px;
  font-size: 12px;
}


.load-more {
  text-align: center;
  margin-top: 40px;
}
.btn-load-more {
  background: transparent;
  color: var(--primary-blue);
  border: 1px solid var(--primary-blue);
  padding: 14px 36px;
  border-radius: 60px;
  font-weight: 600;
  transition: 0.3s;
  cursor: pointer;
  font-size: 16px;
}
.btn-load-more:hover {
  background: var(--light-porcelain);
}

/* ============ 底部预约咨询模块 ============ */
.cta-section {
  margin-bottom: 60px;
}
.cta-inner {
  background: linear-gradient(135deg, #EAF0FB 0%, #F6F8FC 100%);
  border: 1px solid #D6E2F5;
  border-radius: 24px;
  padding: 48px 40px;
  text-align: center;
  color: #0E1F52;
  box-shadow: 0 8px 32px rgba(14,31,82,0.08);
}
.cta-heading {
  font-size: 24px;
  font-weight: 700;
  color: #0E1F52;
  margin-bottom: 10px;
  line-height: 1.45;
}
.cta-sub {
  font-size: 14px;
  color: #5A5E66;
  margin-bottom: 32px;
}
.cta-actions {
  display: flex;
  gap: 14px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 24px;
}
.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 28px;
  border-radius: 50px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.25s;
  text-decoration: none;
}
.cta-btn--primary {
  background: #1F3F8F;
  color: #fff;
}
.cta-btn--primary:hover {
  background: #0E1F52;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(14,31,82,0.22);
}
.cta-btn--outline {
  background: #fff;
  color: #1F3F8F;
  border: 2px solid #1F3F8F;
}
.cta-btn--outline:hover {
  background: #EAF0FB;
  border-color: #0E1F52;
  color: #0E1F52;
  transform: translateY(-2px);
}
.cta-contact-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap;
  color: #7B8794;
  font-size: 12px;
}
.cta-contact-row i { margin-right: 4px; color: #1F3F8F; }
.cta-contact-row .divider { color: #CBD3E0; }

/* ============ 弹窗通用 ============ */
.modal-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(11,26,51,0.65);
  backdrop-filter: blur(4px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.modal-container {
  background: #fff;
  border-radius: 16px;
  width: 90%;
  max-width: 420px;
  box-shadow: 0 20px 60px rgba(14,31,82,0.22);
  overflow: hidden;
}

/* 弹窗头部 */
.modal-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 18px 22px 16px;
  border-bottom: 1px solid #EEF1F8;
  position: relative;
}
.modal-header-icon {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 12px;
  background: #EAF0FB;
  color: #1F3F8F;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.qr-header-icon {
  background: #e8f5e9;
  color: #07c160;
}
.modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #0E1F52;
  margin: 0 0 4px;
}
.modal-subtitle {
  font-size: 13px;
  color: #7b8794;
  margin: 0;
}
.modal-close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background: #F4F6FB;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #5f6a7d;
  font-size: 14px;
  transition: background 0.2s;
}
.modal-close-btn:hover { background: #e2e8f4; }

/* 预约表单 */
.appt-form {
  padding: 16px 22px 22px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
@media (max-width: 480px) {
  .form-row { grid-template-columns: 1fr; }
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.form-group label {
  font-size: 13px;
  font-weight: 600;
  color: #2B2F3A;
}
.form-group .required { color: #e55353; }
.form-group input,
.form-group select,
.form-group textarea {
  padding: 8px 12px;
  border: 1.5px solid #E0E6F0;
  border-radius: 8px;
  font-size: 13px;
  color: #2B2F3A;
  background: #FAFBFD;
  transition: border-color 0.2s, box-shadow 0.2s;
  outline: none;
  resize: vertical;
}
.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  border-color: #1F3F8F;
  box-shadow: 0 0 0 3px rgba(31,63,143,0.1);
  background: #fff;
}
.form-submit-btn {
  width: 100%;
  padding: 11px;
  background: #1F3F8F;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.2s, transform 0.2s;
  margin-top: 4px;
}
.form-submit-btn:hover {
  background: #0e3170;
  transform: translateY(-1px);
}
.form-privacy {
  text-align: center;
  font-size: 12px;
  color: #9ca3af;
  margin: -4px 0 0;
}
.form-privacy i { margin-right: 4px; }

/* 二维码弹窗 */
.qr-modal { max-width: 560px; }
.qr-grid {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
  padding: 24px 28px;
}
.qr-card {
  flex: 1;
  min-width: 180px;
  max-width: 220px;
  background: #F8FAFF;
  border-radius: 16px;
  border: 1px solid #E0E8F8;
  padding: 20px 16px 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.qr-img-wrap {
  width: 160px;
  height: 160px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #dde5f5;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.qr-img { width: 100%; height: 100%; object-fit: cover; display: block; }
.qr-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #9ca3af;
  font-size: 13px;
}
.qr-placeholder i { font-size: 36px; color: #07c160; opacity: 0.5; }
.qr-card-label {
  font-size: 13px;
  font-weight: 600;
  color: #0E1F52;
  line-height: 1.4;
}
.qr-scan-hint {
  font-size: 12px;
  color: #9ca3af;
}
.qr-scan-hint i { margin-right: 4px; }
.qr-footer-tip {
  text-align: center;
  font-size: 13px;
  color: #7b8794;
  padding: 0 28px 22px;
  margin: 0;
}
.qr-footer-tip strong { color: #0E1F52; }

/* 弹窗入场动画 */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease;
}
.modal-fade-enter-active .modal-container,
.modal-fade-leave-active .modal-container {
  transition: transform 0.25s ease, opacity 0.25s ease;
}
.modal-fade-enter-from,
.modal-fade-leave-to { opacity: 0; }
.modal-fade-enter-from .modal-container,
.modal-fade-leave-to .modal-container {
  transform: translateY(24px) scale(0.97);
  opacity: 0;
}

/* 响应式 */
@media (max-width: 992px) {
  .grid-4 { grid-template-columns: repeat(2, 1fr); }
  .grid-3 { grid-template-columns: repeat(2, 1fr); }
  .grid-2 { grid-template-columns: 1fr; }
  .banner .grid-2 { grid-template-columns: 1fr; }
  .timeline-horizontal { flex-wrap: wrap; }
}
@media (max-width: 640px) {
  .grid-4, .grid-3 { grid-template-columns: 1fr; }
  .nav-menu-inner { flex-wrap: wrap; height: auto; }
}
</style>
